/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { billingPlansPlanIdGet$Json } from '../fn/billing-plans/billing-plans-plan-id-get-json';
import { BillingPlansPlanIdGet$Json$Params } from '../fn/billing-plans/billing-plans-plan-id-get-json';
import { billingPlansPlanIdGet$Plain } from '../fn/billing-plans/billing-plans-plan-id-get-plain';
import { BillingPlansPlanIdGet$Plain$Params } from '../fn/billing-plans/billing-plans-plan-id-get-plain';
import { billingPlansPlanIdPut$Json } from '../fn/billing-plans/billing-plans-plan-id-put-json';
import { BillingPlansPlanIdPut$Json$Params } from '../fn/billing-plans/billing-plans-plan-id-put-json';
import { billingPlansPlanIdPut$Plain } from '../fn/billing-plans/billing-plans-plan-id-put-plain';
import { BillingPlansPlanIdPut$Plain$Params } from '../fn/billing-plans/billing-plans-plan-id-put-plain';
import { billingPlansPost$Json } from '../fn/billing-plans/billing-plans-post-json';
import { BillingPlansPost$Json$Params } from '../fn/billing-plans/billing-plans-post-json';
import { billingPlansPost$Plain } from '../fn/billing-plans/billing-plans-post-plain';
import { BillingPlansPost$Plain$Params } from '../fn/billing-plans/billing-plans-post-plain';
import { billingPlansPublicGet$Json } from '../fn/billing-plans/billing-plans-public-get-json';
import { BillingPlansPublicGet$Json$Params } from '../fn/billing-plans/billing-plans-public-get-json';
import { billingPlansPublicGet$Plain } from '../fn/billing-plans/billing-plans-public-get-plain';
import { BillingPlansPublicGet$Plain$Params } from '../fn/billing-plans/billing-plans-public-get-plain';
import { PlanDto } from '../models/plan-dto';

@Injectable({ providedIn: 'root' })
export class BillingPlansApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `billingPlansPublicGet()` */
  static readonly BillingPlansPublicGetPath = '/billing/plans/public';

  /**
   * List public plans.
   *
   * Returns public plans visible on the pricing page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPublicGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPublicGet$Plain$Response(params?: BillingPlansPublicGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlanDto>>> {
    const obs = billingPlansPublicGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List public plans.
   *
   * Returns public plans visible on the pricing page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPublicGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPublicGet$Plain(params?: BillingPlansPublicGet$Plain$Params, context?: HttpContext): Observable<Array<PlanDto>> {
    const resp = this.billingPlansPublicGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PlanDto>>): Array<PlanDto> => r.body)
    );
  }

  /**
   * List public plans.
   *
   * Returns public plans visible on the pricing page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPublicGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPublicGet$Json$Response(params?: BillingPlansPublicGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlanDto>>> {
    const obs = billingPlansPublicGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List public plans.
   *
   * Returns public plans visible on the pricing page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPublicGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPublicGet$Json(params?: BillingPlansPublicGet$Json$Params, context?: HttpContext): Observable<Array<PlanDto>> {
    const resp = this.billingPlansPublicGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PlanDto>>): Array<PlanDto> => r.body)
    );
  }

  /** Path part for operation `billingPlansPlanIdGet()` */
  static readonly BillingPlansPlanIdGetPath = '/billing/plans/{planId}';

  /**
   * Get plan by id.
   *
   * Returns details of a billing plan.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPlanIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPlanIdGet$Plain$Response(params: BillingPlansPlanIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = billingPlansPlanIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get plan by id.
   *
   * Returns details of a billing plan.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPlanIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPlanIdGet$Plain(params: BillingPlansPlanIdGet$Plain$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.billingPlansPlanIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

  /**
   * Get plan by id.
   *
   * Returns details of a billing plan.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPlanIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPlanIdGet$Json$Response(params: BillingPlansPlanIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = billingPlansPlanIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get plan by id.
   *
   * Returns details of a billing plan.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPlanIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingPlansPlanIdGet$Json(params: BillingPlansPlanIdGet$Json$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.billingPlansPlanIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

  /** Path part for operation `billingPlansPlanIdPut()` */
  static readonly BillingPlansPlanIdPutPath = '/billing/plans/{planId}';

  /**
   * Update plan.
   *
   * Updates plan properties, active prices etc.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPlanIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPlanIdPut$Plain$Response(params: BillingPlansPlanIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = billingPlansPlanIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update plan.
   *
   * Updates plan properties, active prices etc.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPlanIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPlanIdPut$Plain(params: BillingPlansPlanIdPut$Plain$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.billingPlansPlanIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

  /**
   * Update plan.
   *
   * Updates plan properties, active prices etc.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPlanIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPlanIdPut$Json$Response(params: BillingPlansPlanIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = billingPlansPlanIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update plan.
   *
   * Updates plan properties, active prices etc.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPlanIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPlanIdPut$Json(params: BillingPlansPlanIdPut$Json$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.billingPlansPlanIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

  /** Path part for operation `billingPlansPost()` */
  static readonly BillingPlansPostPath = '/billing/plans';

  /**
   * Create plan.
   *
   * Creates a plan in the internal catalog. Admin-only operation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPost$Plain$Response(params?: BillingPlansPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = billingPlansPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create plan.
   *
   * Creates a plan in the internal catalog. Admin-only operation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPost$Plain(params?: BillingPlansPost$Plain$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.billingPlansPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

  /**
   * Create plan.
   *
   * Creates a plan in the internal catalog. Admin-only operation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingPlansPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPost$Json$Response(params?: BillingPlansPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = billingPlansPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create plan.
   *
   * Creates a plan in the internal catalog. Admin-only operation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingPlansPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingPlansPost$Json(params?: BillingPlansPost$Json$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.billingPlansPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

}
